import React from "react";
import { Link } from "react-router-dom";
import { FaGithub, FaLinkedin, FaEnvelope, FaWhatsapp, FaArrowUp, FaCode, FaLock } from "react-icons/fa";
import { animateScroll as scroll } from "react-scroll";

const Footer = () => {
  const year = new Date().getFullYear();

  const scrollToTop = () => {
    scroll.scrollToTop({ duration: 500 });
  };

  return (
    <footer className="relative bg-[#0B1120] text-slate-400 py-12 border-t border-slate-800 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
        
        {/* Brand */}
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-blue-600 via-sky-600 to-[#00B4DB] flex items-center justify-center text-white font-black shadow-md shadow-blue-500/20">
            <FaCode size={16} />
          </div>
          <div>
            <p className="text-white font-bold text-base">Partha Debnath</p>
            <p className="text-xs text-slate-400">© {year} Partha Debnath. All rights reserved.</p>
          </div>
        </div>

        {/* Social Pill Links */}
        <div className="flex items-center gap-3">
          <a
            href="https://www.linkedin.com/in/partha-debnath-9630a7190/"
            target="_blank"
            rel="noreferrer"
            className="p-3 bg-[#1E293B] border border-slate-700/80 rounded-xl text-slate-300 hover:text-[#00B4DB] hover:border-[#00B4DB]/40 shadow-sm transition-all"
            aria-label="LinkedIn"
          >
            <FaLinkedin size={18} />
          </a>
          <a
            href="https://github.com/IM-Partha"
            target="_blank"
            rel="noreferrer"
            className="p-3 bg-[#1E293B] border border-slate-700/80 rounded-xl text-slate-300 hover:text-[#00B4DB] hover:border-[#00B4DB]/40 shadow-sm transition-all"
            aria-label="GitHub"
          >
            <FaGithub size={18} />
          </a>
          <a
            href="mailto:parthadebnath466@gmail.com"
            className="p-3 bg-[#1E293B] border border-slate-700/80 rounded-xl text-slate-300 hover:text-[#00B4DB] hover:border-[#00B4DB]/40 shadow-sm transition-all"
            aria-label="Email"
          >
            <FaEnvelope size={18} />
          </a>
          <a
            href="https://wa.me/9476316652"
            target="_blank"
            rel="noreferrer"
            className="p-3 bg-[#1E293B] border border-slate-700/80 rounded-xl text-slate-300 hover:text-[#00B4DB] hover:border-[#00B4DB]/40 shadow-sm transition-all"
            aria-label="WhatsApp"
          >
            <FaWhatsapp size={18} />
          </a>
          <Link
            to="/login"
            className="p-3 bg-[#1E293B] border border-slate-700/80 rounded-xl text-slate-400 hover:text-[#00B4DB] hover:border-[#00B4DB]/40 shadow-sm transition-all"
            title="Admin Login Portal"
          >
            <FaLock size={16} />
          </Link>
        </div>

        {/* Scroll To Top Button */}
        <button
          onClick={scrollToTop}
          className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-slate-400 hover:text-[#00B4DB] transition-colors group cursor-pointer"
        >
          Back To Top
          <span className="p-2.5 rounded-xl bg-[#1E293B] border border-slate-700/80 shadow-sm group-hover:border-[#00B4DB]/50 group-hover:text-[#00B4DB] text-slate-300 transition-colors">
            <FaArrowUp size={12} />
          </span>
        </button>

      </div>
    </footer>
  );
};

export default Footer;
